import React from 'react';
import Icon from 'components/Icon.js';
import {FormattedMessage, defineMessages, injectIntl} from 'react-intl';
import {selectDataSourceById} from 'state/dataSource/dataSourceSelectors';
import {connect} from 'react-redux';
import DataSourceLogo from 'components/DataSourceLogo';
import cx from 'classnames';
import styles from './ColumnSelectItem.css?module';
import {FILTER_TYPE} from 'constants/FilterConstants';
import ButtonUnstyled from 'components/ButtonUnstyled';

const ICONS = {
  date: Icon.OPTIONS.DATATYPE_DATETIME,
  datetime: Icon.OPTIONS.DATATYPE_DATETIME,
  numeric: Icon.OPTIONS.DATATYPE_NUMBER,
  string: Icon.OPTIONS.DATATYPE_TEXT,
};

const MESSAGES = defineMessages({
  numeric: {
    defaultMessage: 'Numeric column type',
    id: 'ColumnSelectItem__NumericIconLabel',
    description: 'Label for icon of column type numeric',
  },
  string: {
    defaultMessage: 'String column type',
    id: 'ColumnSelectItem__StringIconLabel',
    description: 'Label for icon of column type string',
  },
  date: {
    defaultMessage: 'Date column type',
    id: 'ColumnSelectItem__DateIconLabel',
    description: 'Label for icon of column type date',
  },
  datetime: {
    defaultMessage: 'Datetime column type',
    id: 'ColumnSelectItem__DateTimeIconLabel',
    description: 'Label for icon of column type datetime',
  },
});

class ColumnDataSource extends React.Component {
  render() {
    const {dataSource, onClick} = this.props;
    if (!dataSource) return null;

    return (
      <div className={styles.dataSource} onClick={onClick}>
        <DataSourceLogo
          className={styles.dataSourceLogo}
          provider={dataSource.type}
          size={DataSourceLogo.SIZES.SMALL}
        />
        <div className={styles.dataSourceName}>{dataSource.name}</div>
      </div>
    );
  }
}

/* eslint-disable no-class-assign */
ColumnDataSource = connect((state, {dataSourceId}) => ({
  dataSource: selectDataSourceById(state, dataSourceId),
}))(ColumnDataSource);

export class ExpandableColumnSelectItem extends React.Component {
  state = {isOpen: false};

  handleChevronClick = e => {
    e.stopPropagation();
    this.setState({isOpen: !this.state.isOpen});
  };

  render() {
    const {column, onSelect} = this.props;
    const {isOpen} = this.state;

    return (
      <div key={column.name} className={styles.container}>
        <div
          className={styles.main}
          // if they use ExpandableColumnSelectItem and pick all of them - use NAME
          onClick={() => onSelect(column, null, FILTER_TYPE.NAME)}
        >
          <div
            className={cx({
              [styles.arrow]: true,
              [styles.arrowOpen]: isOpen,
            })}
            onClick={this.handleChevronClick}
          >
            <Icon
              className={styles.chevron}
              icon={Icon.OPTIONS.CHEVRON_RIGHT}
              shade={Icon.SHADES.LIGHT}
            />
          </div>
          <Icon icon={ICONS[column.type]} className={styles.typeIcon} />
          <div className={styles.columnName}>{column.name}</div>
          <div className={styles.dataSourceCount}>
            <FormattedMessage
              id="ColumnSelect__DataSourceCount"
              description="Count of datasets sharing a given column name"
              defaultMessage="{count} {count, plural, one {DataSet} other {DataSets}}"
              values={{count: column.dataSourceIds.length}}
            />
          </div>
        </div>
        <div
          className={styles.dataSources}
          style={{
            maxHeight: isOpen ? column.dataSourceIds.length * 112 : 0,
          }}
        >
          {column.dataSourceIds.map(dataSourceId => (
            <ColumnDataSource
              key={dataSourceId}
              dataSourceId={dataSourceId}
              onClick={() =>
                // if they use ExpandableColumnSelectItem but only pick one datasource - use COLUMN_ID
                onSelect(column, dataSourceId, FILTER_TYPE.COLUMN_ID)
              }
            />
          ))}
        </div>
      </div>
    );
  }
}

const ColumnSelectItem = injectIntl(({column, onSelect, intl}) => (
  <div key={column.name} className={styles.container}>
    <ButtonUnstyled
      className={styles.main}
      onClick={() =>
        // if they pick a single column that only has one datasource - use COLUMN_ID
        onSelect(column, column.dataSourceIds[0], FILTER_TYPE.COLUMN_ID)
      }
    >
      <Icon
        title={intl.formatMessage(MESSAGES[column.dataType])}
        icon={ICONS[column.dataType]}
        className={styles.typeIcon}
      />
      <div className={styles.columnName}>{column.name}</div>
    </ButtonUnstyled>
  </div>
));

export default ColumnSelectItem;
